var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgApply(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 62,
    height: 62,
    viewBox: "0 0 62 62",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 1
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M47 31C47 39.8366 39.8366 47 31 47C22.1634 47 15 39.8366 15 31C15 22.1634 22.1634 15 31 15C39.8366 15 47 22.1634 47 31ZM49 31C49 40.9411 40.9411 49 31 49C21.0589 49 13 40.9411 13 31C13 21.0589 21.0589 13 31 13C40.9411 13 49 21.0589 49 31ZM40.7071 26.7071C41.0976 26.3166 41.0976 25.6834 40.7071 25.2929C40.3166 24.9024 39.6834 24.9024 39.2929 25.2929L28.5 36.0858L22.7071 30.2929C22.3166 29.9024 21.6834 29.9024 21.2929 30.2929C20.9024 30.6834 20.9024 31.3166 21.2929 31.7071L27.7929 38.2071C28.1834 38.5976 28.8166 38.5976 29.2071 38.2071L40.7071 26.7071Z",
    fill: "#4D4D4D"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApply);
export default __webpack_public_path__ + "static/media/apply.303eb6c21faffce69df87d54c3563e49.svg";
export { ForwardRef as ReactComponent };